module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_06A.b15a0182.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_06A.mp3
// module id = 117
// module chunks = 0